<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <GmapMap
        ref="gmap"
        :center="center"
        :zoom="10"
        style="width: 100%; height: 400px"
        @click="onMapClick"
      >
        <gmap-marker
          v-if="marker"
          :position="marker"
          :clickable="true"
          :draggable="true"
          @dragend="onDragEnd"
        ></gmap-marker>
      </GmapMap>
    </v-row>
    <h5 class="subtitle-1">Lat: {{ lat }}, Lon: {{ lng }}</h5>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ gelocationByAddress }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "./BasicDialog";
const LOCATION_BY_ADDRESS = gql`
  query locationByAddress($address: String!) {
    gelocationByAddress(address: $address)
  }
`;
export default {
  name: "coordinates-dialog",

  components: { BasicDialog },

  props: {
    value: {
      type: String,
      default: () => "",
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => "Set Coordinates",
    },
    address: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      lat:
        this.value && this.value != "" ? Number(this.value.split(",")[0]) : "",
      lng:
        this.value && this.value != "" ? Number(this.value.split(",")[1]) : "",
    };
  },

  computed: {
    center() {
      return {
        lat: this.lat != "" ? this.lat : 41.902782,
        lng: this.lng != "" ? this.lng : 12.496366,
      };
    },
    marker() {
      return this.lat != "" && this.lng != ""
        ? { lat: Number(this.lat), lng: Number(this.lng) }
        : null;
    },
    isValid() {
      return this.lat != "" && this.lng != "";
    },
  },

  watch: {
    value(newVal) {
      if (newVal && newVal != "") {
        this.lat = Number(newVal.split(",")[0]);
        this.lng = Number(newVal.split(",")[1]);
      }
    },
  },

  methods: {
    onMapClick(event) {
      this.lng = event.latLng.lng();
      this.lat = event.latLng.lat();
    },
    onDragEnd(event) {
      this.lng = event.latLng.lng();
      this.lat = event.latLng.lat();
    },
    onSave() {
      this.$emit("input", `${this.lat},${this.lng}`);
      this.$emit("save");
    },
  },

  apollo: {
    gelocationByAddress: {
      query: LOCATION_BY_ADDRESS,
      variables() {
        return { address: this.address };
      },
      skip() {
        return this.address == "" || !this.show;
      },
      result({ data }) {
        if (
          (this.value == "" || this.value == null) &&
          data.gelocationByAddress != ""
        ) {
          this.lat = Number(data.gelocationByAddress.split(",")[0]);
          this.lng = Number(data.gelocationByAddress.split(",")[1]);
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/CoordinatesDialog.vue